module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cC4sU"))).then(() => parcelRequire('8rm4T'));